<div class="row col-12 p-0 m-0 main-page-section ">

  <div class="col-12 p-0 employee-section">

    <div class="col-height">

      <div>

        <div class="breadcrumbs-section padding-left">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Invitation Approval</span>
        </div>

        <div class="invite-layout">

          <div class="row" style="align-items: flex-end;">
            <h1 class="col-12">Invitation Approval</h1>
          </div>

          <div class="row mt-4">
            <p class="col-12">You have received {{pendingList.length}} requests.</p>
          </div>

          <ng-container *ngIf="pendingList">
            <div *ngFor="let item of pendingList|slice:0:pendingSlice;let ind=index" style="cursor: pointer;">
              <div class="row meeting-row mt-2 ml-0 ">

                <div (click)="navigateToDetail(item.invitationID)" class="col-8 pl-4 pt-1">

                  <div style="display: flex;">
                    <p class="name" *ngFor="let name of item?.t0600Vmsguests|slice:0:2;last as isLast">
                      {{name.fullName|titlecase}}<span *ngIf="!isLast" class="pr-1">,</span></p><span class="name"
                      *ngIf="item?.t0600Vmsguests?.length>2">+ {{item?.t0600Vmsguests?.length-2}}
                      more</span>
                  </div>
                  <p class="detail">
                    {{item?.parkUser?.userName}}&nbsp;<span
                      *ngIf="item?.parkUser?.userName">|</span>&nbsp;{{item?.hostCompanyName}}&nbsp;<span
                      *ngIf="item?.hostCompanyName">|</span>&nbsp;Request sent on
                    {{item?.createdDate| customDate}}</p>

                </div>
                <div class="col-2"> </div>
                <div class="col-2 name" *ngIf="vmsApprove || vmsReject">
                  <button type="submit" class="dc"
                    (click)="openOptionDrawerPending[ind] = !openOptionDrawerPending[ind];globalIndex = ind">Reject</button>
                  <div *ngIf="openOptionDrawerPending[ind]" class="drawer-container dc">
                    <div class="popup-title dc">Comments</div>
                    <div class="popup-input dc">
                      <input class="input dc" maxlength="200" type="text" id="message_{{ind}}"
                        (keyup)="checkValidation(ind)" [(ngModel)]="rejectionValue[ind]" #message_{{ind}}>
                      <p *ngIf="error[ind]" style="font-size: 12px;color: red;">*Comments is required</p>
                    </div>
                    <div class="popup-footer dc">
                      <p class="dc" (click)="rejectRequest(item.invitationID, ind, false)">Reject</p>
                    </div>
                  </div>
                  |
                  <button type="submit" (click)="rejectRequest(item.invitationID, ind, true)">Approve</button>

                </div>
              </div>
            </div>

            <div class="row" *ngIf="pendingList.length>5">
              <div class="col-12 align-right">
                <button (click)="viewMore()">View {{pendingList.length - pendingSlice}} more requests</button>
              </div>
            </div>

            <hr class="ml-0">
          </ng-container>

          <ng-container *ngIf="historyList">
            <div class="row">
              <div class="col-12">
                <h2>History</h2>
              </div>
            </div>



            <div *ngFor="let item of historyList|slice:0:5; let ind=index" style="cursor: pointer;">
              <div class="row meeting-row mt-2 ml-0 pr-2 ">

                <div (click)="navigateToDetail(item.invitationID)" class="col-8 pl-4 pt-1">
                  <div style="display: flex;">
                    <p class="name" *ngFor="let name of item?.t0600Vmsguests|slice:0:2;last as isLast">
                      {{name.fullName|titlecase}}<span *ngIf="!isLast" class="pr-1">,</span></p><span class="name"
                      *ngIf="item?.t0600Vmsguests?.length>2">+ {{item?.t0600Vmsguests?.length-2}}
                      more</span>
                  </div>
                  <p class="detail">
                    {{item?.parkUser?.userName}}&nbsp;<span
                      *ngIf="item?.parkUser?.userName">|</span>&nbsp;{{item?.hostCompanyName}}&nbsp;<span
                      *ngIf="item?.hostCompanyName">|</span>&nbsp;Request sent on
                    {{item?.createdDate| customDate}}</p>

                </div>
                <div class="col-1"> </div>
                <div class="hc col-3 align-right">
                  <button *ngIf="item?.isApproved==false">{{item.remarks=='Auto Rejected'?'Missed
                    Approval':'Rejected'}}</button><img src="assets/images/ButtonInfo.png" class="hc"
                    style="cursor: pointer;" *ngIf="item?.isApproved==false"
                    (mouseout)="openOptionDrawerHistory[ind] = !openOptionDrawerHistory[ind];globalIndex1 = ind"
                    (mouseover)="openOptionDrawerHistory[ind] = !openOptionDrawerHistory[ind];globalIndex1 = ind" />
                  <div *ngIf="openOptionDrawerHistory[ind]" class="drawer-container-hc hc">
                    <div class="popup-title-hc hc">Action taken on {{item.approvalDate | customDate}}</div>
                    <div class="popup-input-hc hc" style="display: flex;align-items: baseline;">
                      <span class="hc" style="color: #AAAAAA;">Comment:&nbsp;</span>
                      <p class="hc comment" style="color: #01539A;">{{item.remarks}}</p>
                    </div>
                  </div>

                  <div>
                    <button *ngIf="item?.isApproved">Approved</button>
                    <div class="row" *ngIf="item?.isApproved==true">
                      <div class="col-12">
                        <p class="green-text" *ngIf="item?.approvedByAdminName==null">on
                          {{formatDateApproval(item?.approvalDate,'date')}}</p>
                        <p class="green-text" *ngIf="item?.approvedByAdminName!=null">by
                          {{item?.approvedByAdminName}} on
                          {{formatDateApproval(item?.approvalDate,'date')}}</p>
                      </div>
                    </div>
                  </div>

                  <button *ngIf="item?.isApproved==null">Missed Approval</button>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 align-right">
                <a routerLink="/bulk-invite-approval/history"><button>View history for the last 90 days.</button></a>
              </div>
            </div>
          </ng-container>


        </div>


      </div>

    </div>
  </div>
</div>